import { Map, RotateCcw, ShoppingCart, Flag } from 'lucide-react';
import { useQuiz } from '../context/QuizContext';
import { useGameAudio } from '../hooks/useGameAudio';
import { CharacterPortrait } from '../components/CharacterPortrait/CharacterPortrait';
import { GameShell } from '../components/layout/GameShell';

export function GameOverScreen() {
  const { state, dispatch } = useQuiz();
  const { playHover, playClick } = useGameAudio();
  const temCheckpoint = state.checkpointAtual > 0;
  const perguntaCheckpoint = state.checkpointAtual + 1;

  return (
    <GameShell maxWidth="md" maxHeightCeiling="max-h-[min(100%,40rem)]" center>
      {/* Módulo coeso com teto: em telas altas o card NÃO estica com vãos de
          150px entre os blocos (medido em 430×932) — os 3 blocos ficam unidos
          pelo gap contido e a folga vira moldura externa. */}
      <div className="w-full stage-module items-center text-center p-3.5 sm:p-5 my-auto glass-panel rounded-2xl border-red-500/40 animate-in zoom-in-95 duration-300 shadow-[0_0_25px_rgba(239,68,68,0.2)]">

        {/* Topo — Retrato de Derrota & Título SciFi */}
        <div className="flex flex-col items-center shrink-0">
          <CharacterPortrait
            fase={state.faseAtual}
            variant="portal"
            mood="error"
            eager
            className="mb-2 shrink-0 border-2 border-red-500/50 shadow-[0_0_15px_rgba(239,68,68,0.4)]"
          />
          <h2 className="text-fluid-hero font-cyber font-black text-red-500 tracking-wider uppercase drop-shadow-[0_0_10px_rgba(239,68,68,0.7)] leading-tight">
            Sem Búzios Vitais
          </h2>
          <p className="text-slate-400 text-fluid-sm mt-1 max-w-xs leading-relaxed">
            Sua energia espiritual se esgotou na <strong className="text-red-400 font-cyber">Pergunta {state.indicePerguntaAtual + 1}</strong>. Escolha seu destino para continuar.
          </p>
        </div>

        {/* Informações da tentativa */}
        <div className="w-full bg-slate-950/60 border border-red-500/20 p-2.5 rounded-xl flex items-center justify-around text-fluid-sm shrink-0 my-1">
          <div className="flex flex-col items-center">
            <span className="text-slate-400 text-[10px] font-cyber uppercase tracking-wider">Fase</span>
            <span className="font-cyber font-bold text-white text-xs sm:text-sm">{state.faseAtual}</span>
          </div>
          <div className="h-6 w-px bg-slate-800"></div>
          <div className="flex flex-col items-center">
            <span className="text-slate-400 text-[10px] font-cyber uppercase tracking-wider">Progresso</span>
            <span className="font-cyber font-bold text-amber-400 text-xs sm:text-sm">{state.indicePerguntaAtual + 1}/16</span>
          </div>
          <div className="h-6 w-px bg-slate-800"></div>
          <div className="flex flex-col items-center">
            <span className="text-slate-400 text-[10px] font-cyber uppercase tracking-wider">Axé Mantido</span>
            <span className="font-cyber font-bold text-emerald-400 text-xs sm:text-sm">{state.moedas}</span>
          </div>
        </div>

        {/* Zona do Polegar: 4 Botões Ergonomicamente Empilhados */}
        <div className="flex flex-col gap-2 w-full shrink-0">
          <button
            onMouseEnter={playHover}
            onClick={() => { playClick(); dispatch({ type: 'RESTART_PHASE' }); }}
            className="btn-cyber w-full py-2.5 rounded-xl bg-emerald-600/20 border border-emerald-500/50 text-emerald-100 font-cyber font-bold tracking-wider hover:bg-emerald-600/40 transition flex items-center justify-center gap-2 text-fluid-body shadow-sm"
          >
            <RotateCcw size={15} />
            Reiniciar fase (Pergunta 1 · 5 búzios)
          </button>

          <button
            onMouseEnter={playHover}
            onClick={() => { playClick(); dispatch({ type: 'RESUME_FROM_CHECKPOINT' }); }}
            disabled={!temCheckpoint}
            className="btn-cyber w-full py-2.5 rounded-xl bg-amber-600/20 border border-amber-500/50 text-amber-100 font-cyber font-bold tracking-wider hover:bg-amber-600/40 transition flex items-center justify-center gap-2 text-fluid-body disabled:opacity-30 disabled:grayscale"
            title={temCheckpoint ? undefined : 'Nenhum save point registrado nesta tentativa'}
          >
            <Flag size={15} />
            Continuar do checkpoint (Pergunta {temCheckpoint ? perguntaCheckpoint : '—'} · 2 búzios)
          </button>

          <button
            onMouseEnter={playHover}
            onClick={() => { playClick(); dispatch({ type: 'NAVIGATE', payload: 'FASE_SELECT' }); }}
            className="btn-cyber w-full py-2.5 rounded-xl bg-slate-800 border border-slate-600 text-white font-cyber font-bold tracking-wider hover:bg-slate-700 transition flex items-center justify-center gap-2 text-fluid-body"
          >
            <Map size={15} />
            Voltar ao mapa de fases
          </button>

          <button
            onMouseEnter={playHover}
            onClick={() => { playClick(); dispatch({ type: 'NAVIGATE', payload: 'TENDA' }); }}
            className="btn-cyber w-full py-2 rounded-xl border border-amber-500/30 text-amber-400 font-cyber text-fluid-sm tracking-wider hover:border-amber-400 transition flex items-center justify-center gap-2"
          >
            <ShoppingCart size={14} />
            Ir para Tenda de Saberes
          </button>
        </div>

      </div>
    </GameShell>
  );
}
